import { mqMin, space } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { css, styled } from 'styled-components'

interface FormFieldStateProps {
  $error?: boolean
  $horizontalLabel?: boolean
}

export const FormField = styled.div.attrs<FormFieldStateProps>(({ as = 'label' }) => ({
  as,
}))<FormFieldStateProps>`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_4')};
  user-select: none;
  ${({ $horizontalLabel }) => $horizontalLabel && modHorizontalLabel()}
`

export const FormFieldLabel = styled(Typography).attrs({
  variant: 'body-m-regular-tight',
})``

export const FormFieldControl = styled.div``

export const FormFieldMessageContainer = styled.div`
  @media ${mqMin('primitives_breakpoint_m_min')} {
    margin-top: ${space('primitives_space_8')};
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    gap: ${space('primitives_space_8')};
  }
`

function modHorizontalLabel() {
  return css`
    @media ${mqMin('primitives_breakpoint_m_min')} {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-template-rows: auto 1fr;
      column-gap: ${space('primitives_space_12')};
      gap: ${space('primitives_space_0')};

      ${FormFieldLabel} {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        text-align: right;
      }
    }
  `
}
